import { Alert, Box, Button, Container, CssBaseline, TextField, ThemeProvider, useTheme } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from 'src/util/authenticationProvider';
import { PrizeDto } from 'src/util/types';
import config from '../../../../config';
import PrizeList from './PrizeList';
import { useTranslation } from 'react-i18next';

export default function PrizeManagement(){
  const authContext = useAuth();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [prizes, setPrizes] = useState<PrizeDto[]>([]);
  const {t} = useTranslation();

  useEffect(() => {
    axios.get(config.apiUrl +"/api/prize/all",{
      headers: {
        'Authorization': 'Bearer ' + authContext.token
      }
    })
      .then(response => {
        setPrizes(response.data.content);
      })
      .catch(err => console.log(err))
  }, []);
  const handleSubmitData = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    const formData = new FormData(event.currentTarget);

    axios.post(config.apiUrl + "/api/prize/create", formData, {
      headers: {
        "Authorization": "Bearer " + authContext.token,
        "Content-Type": "multipart/form-data"
      }
    })
      .then(response => {
        console.log("Creation successful.");
        //prizes.push(response.data.content);
        setPrizes([...prizes, response.data.content]);
        setSuccess('Creation successful.');
      })
      .catch(() => {
        console.log("Connection to Server failed.");
        setError('Connection to Server failed.')
      })

  }

  const handleDeleteUpdate = (id) => {
    setPrizes(prizes.filter(prizeDto => prizeDto.id !== id));
  }

  return(
    <>
      <ThemeProvider theme={useTheme}>
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box component="form" onSubmit={handleSubmitData} noValidate sx={{ mt: 1 }}>
        <TextField
            margin="normal"
            fullWidth
            id="description"
            label={t('field.Description')}
            name="description"
            autoComplete="description"
            autoFocus
          />
          <TextField
            margin="normal"
            type="file"
            required
            fullWidth
            id="image"
            name="image"
          />
        
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t('general.Create')}
          </Button>
        </Box>
        {error ? <Alert severity="error">{error}</Alert> : ''}
        {success ? <Alert severity="success">{success}</Alert> : ''}
      </Box>
      <PrizeList rows={prizes} deleteCallback={handleDeleteUpdate}/>
    </Container>
  </ThemeProvider>
    </>
  );
}